export default {
  name: 'guestinvite',
  components: {},
  props: [],
  data () {
    return {

    }
  },
  computed: {
    user () {
      return this.$store.getters.userData
    }
  },
  mounted () {

  },
  methods: {
    async acceptInvite() {

      console.log(`checking Invite:`, this.$route.query.id);
      // if user is logged 
      // make call to API to accept the invite

      let obj = {
        id: this.user.id,
        email: this.user.email,
        inviteID: this.$route.query.id,
        org: this.$route.query.orgid
      }

      console.log('obj to post:', obj);

      let res = await fetch('/api/acceptGuestInvite', {
        method: 'post',
        body: JSON.stringify(obj),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })

      res = await res.json();

      console.log("res:", res);

      if(!res.error){
        await this.$store.dispatch('getOrgs', this.user)
        await this.$store.dispatch("updateUserData", {
          uid: this.user.id,
          key: `orgs.${this.$route.query.orgid}`,
          value: {
            favs: [],
            bookings: []
          },
        });
        this.$toast.success(this.$t('user-Invite-accepted'));
        this.$router.push(`/${this.$route.params.org}`)
      } else {
        console.log("error accepting invite:", res.message)
        this.$toast.error(this.$t("toast-Error")+res.message);
      }
    }
  }
}
